import { render, staticRenderFns } from "./CheckTypeASelectorNHSafe.vue?vue&type=template&id=fb5af47e&scoped=true"
import script from "./CheckTypeASelectorNHSafe.vue?vue&type=script&lang=js"
export * from "./CheckTypeASelectorNHSafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5af47e",
  null
  
)

export default component.exports